// extracted by mini-css-extract-plugin
module.exports = {"price":"FormattedPrice_price__1GQ8a","price__pounds":"FormattedPrice_price__pounds__1IM9s","price__cut":"FormattedPrice_price__cut__2-kL8"};